import type { DataState } from '@/stores/dataStore';
import type { Message } from '@/types/api';

/**
 * Narrow store reads for the DM list, meant for `useShallow`: each returns a
 * per-DM record whose values only change when that conversation changes, so
 * a message, typing ping or unread bump in a guild channel no longer
 * re-renders the whole list (it subscribed to the entire maps before).
 */

export function selectDmNewest(s: DataState): Record<string, Message | undefined> {
  const out: Record<string, Message | undefined> = {};
  for (const id of s.dmOrder) out[id] = s.messagesByChannel[id]?.[0];
  return out;
}

export function selectDmTyping(myId: string | null) {
  return (s: DataState): Record<string, boolean> => {
    const out: Record<string, boolean> = {};
    for (const id of s.dmOrder) {
      const typers = s.typingByChannel[id];
      out[id] = !!typers && Object.keys(typers).some((uid) => uid !== myId);
    }
    return out;
  };
}

export function selectDmUnread(s: DataState): Record<string, number> {
  const out: Record<string, number> = {};
  for (const id of s.dmOrder) out[id] = s.unreadByChannel[id] ?? 0;
  return out;
}

export function selectDmMentions(s: DataState): Record<string, number> {
  const out: Record<string, number> = {};
  for (const id of s.dmOrder) out[id] = s.mentionByChannel[id] ?? 0;
  return out;
}
